module.exports = __webpack_public_path__ + "img/Logo-Up-MultiBeneficii.627651de.svg";